'use strict';

/* Controllers */

angular.module('app')
  .controller('AppCtrl', ['$scope', '$translate', '$localStorage', '$window',  '$http',  '$location', '$interval', '$state', '$rootScope',
    function(              $scope,   $translate,   $localStorage,   $window,    $http,    $location,   $interval,   $state,   $rootScope ) {
      // add 'ie' classes to html
      var isIE = !!navigator.userAgent.match(/MSIE/i);
      isIE && angular.element($window.document.body).addClass('ie');
      isSmartDevice( $window ) && angular.element($window.document.body).addClass('smart');

      // config
      $scope.app = {
        dev: false,
        name: dbType.abrv,
        bdname: dbType.abrv,
        version: '2.10',
        website: dbType.name,
        mainwebsite: dbType.website,
        domain: dbType.domain,
        userTxt: dbType.isDemo ? 'User' : 'Email',
        // for chart colors
        color: {
          bfi:     '#43a953',
          bfiLight:'#bee7c4',
          bfiDark: '#10621d',
          bfiHover:'#79c184',
          blue:    '#0a44c7',
          primary: '#7266ba',
          info:    '#23b7e5',
          success: '#27c24c',
          warning: '#fad733',
          danger:  '#f05050',
          light:   '#e8eff0',
          dark:    '#3a3f51',
          black:   '#1c2b36'
        },
        settings: {
          themeID: 1,
          navbarHeaderColor: 'bg-black',
          navbarCollapseColor: 'bg-white-only',
          asideColor: 'bg-black',
          headerFixed: true,
          asideFixed: false,
          asideFolded: false,
          asideDock: false,
          container: false
        }
      }
      
      //Demo
      $scope.isDemo = dbType.isDemo;
      
      $scope.bdType = dbType.database;
      
           
      //Get URL Path
      $scope.app.url = aurl;
      
      //Exclude domain test
      $scope.excludeDM = function(path) {
          if(path.indexOf('mad') > -1)
              return true;
      }
      
      
      // save settings to local storage
      if ( angular.isDefined($localStorage.settings) ) {
        $scope.app.settings = $localStorage.settings;
      } else {
        $localStorage.settings = $scope.app.settings;
      }
      $scope.$watch('app.settings', function(){
        if( $scope.app.settings.asideDock  &&  $scope.app.settings.asideFixed ){
          // aside dock and fixed must set the header fixed.
          $scope.app.settings.headerFixed = true;
        }
        // save to local storage
        $localStorage.settings = $scope.app.settings;
      }, true);

      // angular translate
      $scope.lang = { isopen: false };
      $scope.langs = {en:'English', de_DE:'German', it_IT:'Italian'};
      $scope.selectLang = $scope.langs[$translate.proposedLanguage()] || "English";
      $scope.setLang = function(langKey, $event) {
        // set the current lang
        $scope.selectLang = $scope.langs[langKey];
        // You can change the language during runtime
        $translate.use(langKey);
        $scope.lang.isopen = !$scope.lang.isopen;
      };

      function isSmartDevice( $window )
      {
          // Adapted from http://www.detectmobilebrowsers.com
          var ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];
          // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
          return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);
      }
      
      //Active Button
      $scope.getClass = function(path, classnm) {
            if ($location.path().substr(0, path.length) == path) {
              return "active " + classnm;
            } else {
              return classnm;
            }
        }
        
        //Logo url
      $scope.getLogo = function(domain) {
            if (domain == 'bfi') {
              return aurl + 'img/' + domain + '-logo-new-3.png';
            }  
            
            if (domain == 'bwi') {
              return aurl + 'img/' + domain + '-logo.svg';
            }
        }
       
        
      //Logout
      $scope.bdnLogout = function() {
          $http({
                url: MyAjax.ajaxurl,
                ignoreLoadingBar: true,
                method: "GET",
                params:{
                        action: 'log_out_user',
                    },
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(function(response) {
//                   if($scope.excludeDM($rootScope.$bdomain)){
//                       window.location.href = $rootScope.$bdomain;
//                   }   
//                   else
                    if(response.data.logout == "Logout Successful"){
                       window.location.href = 'https://'+$scope.app.mainwebsite;
                   }
                   else {
                       return false;
                   }

            });
          
        }  
        
      //Header data
      $http({
        url: MyAjax.ajaxurl,
        method: "GET",
        params:{
                action: 'get_header_info',
            },
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function(response) {

          
        if ( !response.user ) {
          //  console.log(response.data);
          $scope.data = response.data;
          
        }else{
          //window.location.reload();
        }
      }, function(x) {
        $scope.authError = 'Server Error';
      });
    
        
      //Run every 2 min  = 60.000 
        var LockDown = $interval(function() {     
            //Lockdown
            $http({
              url: MyAjax.ajaxurl,
              ignoreLoadingBar: true,
              method: "GET",
              params:{
                      action: 'lock_add',
                  },
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function(response) {

              if ( response.data.lockdownon && response.data.lockdownon == 'true' ) {
                  window.location.reload();
              }
            }, function(x) {
              $scope.authError = 'Server Error';
              if( x.status == 400){
                    window.location.reload();
                }
            });
            
        }, 7200000, 0);   //300.000 = 5 min; 7200000 = 120min

        $scope.$on('$destroy', function () { $interval.cancel(LockDown); });
        
}]).run(function($rootScope, $http, $state) {
        $rootScope.click_logs = function( id, type, clicktype, link = false ) {
            // console.log(id);
            if( $(id).length == 0 )
                return;

            $( id ).on( "click", function(event) {
               event.preventDefault();
               event.stopPropagation();
                
                var clickBut = {};
                    clickBut.type = type;
                    clickBut.clicktype = clicktype;
                
                
                $http({
                    url: MyAjax.ajaxurl,
                    ignoreLoadingBar: true,
                    method: "POST",
                    params:{
                            action: 'bdn_click_log',
                        },
                    data: angular.toJson(clickBut), 
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  }).then(function(response) {
                      //console.log(response.data.user);
                      //window.open( link, '_blank' );
                      if( link ){
                          $state.go(link);
                      }

                  }, function(x) {
                    $scope.authError = 'Server Error';
                  });

            });
        };
        
        $rootScope.save_logs = function( type, clicktype, link = false ) {
           
                var clickBut = {};
                    clickBut.type = type;
                    clickBut.clicktype = clicktype;                
                
                $http({
                    url: MyAjax.ajaxurl,
                    ignoreLoadingBar: true,
                    method: "POST",
                    params:{
                            action: 'bdn_click_log',
                        },
                    data: angular.toJson(clickBut), 
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  }).then(function(response) {
                      //console.log(response.data.user);
                      //window.open( link, '_blank' );
                      if( link ){
                          $state.go(link);
                      }

                  }, function(x) {
                    $scope.authError = 'Server Error';
                  });

           
        };
        
        $rootScope.dw_logs = function( id ) {                
            var clickBut = {};
            
            if( $(id).length == 0 )
                return;
            
            $( id ).on( "click", function(event) {
                event.preventDefault();
                event.stopPropagation();
                
                var cntVal = $( '#bfi-table_length option:selected' ).text();
                    
                if ( cntVal !== "" ){
                    clickBut.cnt = cntVal;
                    $http({
                        url: MyAjax.ajaxurl,
                        ignoreLoadingBar: true,
                        method: "POST",
                        params:{
                                action: 'bdn_dwclick_log',
                            },
                        data: angular.toJson(clickBut), 
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      }).then(function(response) {
                          if( typeof response.data != 'undefined' && response.data.cnt ) {
                            if( parseInt(response.data.cnt) > 1000 ){
                                  $( id ).hide();
                                  if ( !$( ".dw-limit" ).length ) {
                                      $( ".dt-buttons" ).append( '<div class="dw-limit badge badge-green">Export limit for 24 hours reached.</div>' );
                                  }
                            }
                          }

                      }, function(x) {
                        $scope.authError = 'Server Error';
                      });     
                }
                      
            });   
        };
    });